import React from 'react';
import PropTypes from 'prop-types';
import { Trans, useTranslation } from 'react-i18next';
import { Spacing, Icon, Text, Button, FlatButton } from '@reservamos/elements';
import dotersLogo from 'images/doters/greendoters.svg';
import adultIcon from 'images/passengers/adult-icon.png';
import ModalWithTheme from 'components/ModalWithTheme';

/**
 * GuestCheckoutConfirmationModal component.
 * Render a modal asking the user if they want to purchase as a guest, warning that they won't accumulate points in their doters account.
 * @param {Object} props - Component props
 * @param {Function} props.onConfirm - Callback when user confirms guest purchase
 * @param {Function} props.onCancel - Callback when user cancels
 */
const GuestCheckoutConfirmationModal = ({ onConfirm, onCancel }) => {
  const { t } = useTranslation('passengers');

  return (
    <ModalWithTheme
      centeredOnMobile
      responsiveSize="auto"
      borderRadiusBigger
      contentHeight="auto"
      onCloseModal={onCancel}
    >
      <Spacing vertical>
        <div className="flex gap-4 items-center justify-center">
          <Icon type={dotersLogo} size="L" />
          <Icon type="ArrowForward" color="grayLight" />
          <div className="border border-dashed border-gray flex shadow-md bg-white w-[35px] h-[35px] rounded-full items-center justify-center">
            <Icon type={adultIcon} size="S" />
          </div>
        </div>
        <Spacing vertical size="S">
          <Text size="L" weight="bold" textAlign="center">
            {t('guest_checkout_modal.title')}
          </Text>
          <Text textAlign="center">
            <Trans t={t} i18nKey="guest_checkout_modal.description">
              <b />
            </Trans>
          </Text>
        </Spacing>
        <Spacing justifyContent="space-between">
          <Button
            isRounded
            padding="XL"
            text={t('guest_checkout_modal.cancel_button')}
            variant="primary"
            onClick={onCancel}
          />
          <FlatButton
            text={t('guest_checkout_modal.confirm_button')}
            type="primary"
            onClick={onConfirm}
          />
        </Spacing>
      </Spacing>
    </ModalWithTheme>
  );
};

GuestCheckoutConfirmationModal.propTypes = {
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default GuestCheckoutConfirmationModal;
